import globalColors from './globalColors';

const primary = {
  light: '#E97D67',
  main: '#E66950',
  dark: '#CF5E48'
};

const primary1 = {
  light: '#E97D67',
  main: '#E66950',
  dark: '#CF5E48'
};

const secondary = {
  light: '#BC371B',
  main: '#BC371B',
  dark: '#BC371B'
};

const disabledColor = '#424242';
const disabledTextColor = 'rgba(255, 255, 255, 0.3)';

const defaultText = {
  color: '#FFFFFF',
  background: '#424242'
};

const hoverColor = '#515151';

const lightOrange = {
  dark: true,
  palette: {
    ...globalColors,
    type: 'dark',
    secondary,
    primary,
    navBarInput: '#FFF',
    externalCodeColor: '#F8D5CD',
    background: {
      default: '#333333'
    },
    header: '#333',
    scrollColor: primary1.dark,
    navDrawer: {
      toolbarBoxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
      backGround: '#333',
      itemHover: '#515151',
      dividerColor: '#333',
      itemSelected: '#424242',
      itemSelectedBorder: '#424242',
      scrollColor: '#424242'
    },
    sideBar: {
      itemActive: {
        background: primary1.light,
        color: '#fff'
      },
      itemHover: {
        background: hoverColor
      },
      toggleButton: defaultText.background,
      toggleButtonColor: '#FFF'
    },
    table: {
      green: {
        lighter: '#effaef',
        light: '#d2f0d2',
        main: '#aae1aa',
        dark: '#66bb6a'
      }
    },
    ddSelector: {
      ...defaultText,
      item: defaultText.background,
      itemHover: hoverColor,
      itemSelected: primary.light,
      borderColor: 'rgba(255, 255, 255, 0.23)'
    },
    hoverBackgroundColor: 'rgba(255, 255, 255, 0.04)',
    disabled: disabledColor,
    disabledText: disabledTextColor,
    input: {
      ...defaultText,
      '&:disabled': {
        background: disabledColor
      }
    },
    text: defaultText,
    subTextColor: '#c7c7c7',
    icon: '#fff',
    modalHeaderColor: primary.main,
    plannerJumbotron: disabledColor,
    deleteButton: {
      float: 'left',
      background: '#d9534f',
      color: '#FFF',
      '&:hover': {
        background: '#c9302c'
      }
    },
    reactTable: {
      ...defaultText,
      oddRow: '#4B4B4B',
      filterBorderColor: '#FFF'
    },
    muiTable: {
      header: {
        backgroundColor: '#E97D67',
        color: '#FFF'
      }
    },
    listItem: {
      secondaryText: '#F8D5CD'
    },
    paperBorderColor: 'rgba(255, 255, 255, 0.12)',
    reportTable: {
      container: {
        height: '100%',
        background: '#e2e7eb',
        borderLeft: '1px solid #546e7a',
        '& .ReactVirtualized__Table__Grid': {
          outline: 'none'
        }
      },
      header: {
        background: '#546e7a',
        color: '#FFF',
        borderColor: '#fff',
        '& .weekEndDay': {
          background: '#c6efce',
          color: '#006100',
          borderColor: '#fff'
        },
        '& .holiday': {
          color: '#FFF',
          background: '#FCB92E'
        },
        '& .short-day': {
          color: '#FFF',
          background: '#FDD580'
        }
      },
      errorRow: {
        background: '#c6666d!important',
        '&:hover': {
          background: '#e2898f!important'
        }
      },
      activeRow: {
        color: '#FFF!important',
        background: '#7CC981!important',
        '&:hover': {
          background: '#84da8b!important'
        }
      },
      bodyCells: {
        '& .holiday': {
          background: '#FEE8BA',
          color: '#006100',
          borderColor: 'inherit'
        },
        '& .short-day': {
          background: '#FEF1D6',
          color: '#006100',
          borderColor: 'inherit'
        }
      },
      departmentRow: {
        background: '#718e9d',
        color: '#FFF',
        borderColor: '#546e7a!important',
        '&:hover': {
          background: '#90A7B2'
        },
        '& .weekEndDay': {
          background: '#D6F3DC',
          color: '#006100'
        }
      },
      userNameRow: {
        background: '#9db0bb',
        color: '#FFF',
        borderColor: '#546e7a!important',
        borderColorOptional: '#546e7a',
        '&:hover': {
          background: '#c0ced3'
        },
        '& .weekEndDay': {
          background: '#D6F3DC',
          color: '#006100'
        }
      },
      userOverUnderTimeRow: {
        background: '#b4c2cb',
        color: '#FFF',
        borderColor: '#546e7a!important',
        '& .weekEndDay': {
          background: '#D6F3DC',
          color: '#006100'
        }
      },
      userPlannedHoursRow: {
        background: '#c9d3da',
        color: '#40545e',
        borderColor: '#9db0bb!important',
        '& .weekEndDay': {
          background: '#E9F8EC',
          color: '#006100'
        }
      },
      userDifferenceRow: {
        background: '#d4dde2',
        color: '#40545e',
        borderColor: '#9db0bb!important',
        '& .weekEndDay': {
          background: '#E9F8EC',
          color: '#006100'
        }
      },
      userAbsencesRow: {
        background: '#d4dde2',
        color: '#40545e',
        borderColor: '#9db0bb!important',
        '& .weekEndDay': {
          background: '#E9F8EC',
          color: '#006100'
        }
      },
      actionGeneralRow: {
        background: '#e2e7eb',
        color: '#333',
        borderColor: '#d4d4d4!important',
        '& .weekEndDay': {
          background: '#F0FBF2',
          color: '#006100'
        }
      },
      actionByTypeRow: {
        background: '#e2e7eb',
        color: '#333',
        borderColor: '#d4d4d4!important',
        '& .weekEndDay': {
          background: '#F0FBF2',
          color: '#006100'
        }
      }
    },
    calendar: {
      color: '#FFF',
      disabledBackground: '#515151',
      background: '#424242',
      headerBackground: '#E66950',
      headerBackgroundHover: '#CF5E48',
      headerColor: '#FFF',
      headerBorder: '#FFF',
      borderColor: '#FFF',
      hourBorderColor: '#C1C1C1'
    }
  },
  overrides: {
    MuiFormLabel: {
      root: {
        fontSize: '13px',
        fontWeight: 700,
        lineHeight: 1.5,
        color: defaultText.color
      }
    },
    MuiFormControlLabel: {
      label: {
        color: defaultText.color
      }
    },
    MuiButton: {
      containedPrimary: {
        color: '#FFF',
        '& svg': {
          color: '#FFF'
        }
      },
      containedSecondary: {
        backgroundColor: '#252525',
        border: '1px solid #424242',
        color: '#FFF',
        '&:hover': {
          backgroundColor: '#BC371B',
          borderColor: '#BC371B'
        },
        '& svg': {
          color: '#FFF'
        }
      }
    },
    MuiCheckbox: {
      colorSecondary: {
        color: '#FFF',
        '&$checked': {
          color: '#BC371B'
        }
      }
    },
    MuiList: {
      root: {
        overflowY: 'auto',
        flex: 1,
        '&::-webkit-scrollbar': {
          width: 5
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 5px grey',
          borderRadius: 3
        },
        '&::-webkit-scrollbar-thumb': {
          background: primary.dark,
          borderRadius: 5
        }
      }
    },
    MuiListItem: {
      root: {
        '&:hover': {
          background: hoverColor
        },
        '&$selected': {
          background: primary1.light,
          color: '#FFF',
          '&:hover': {
            background: primary1.light
          }
        }
      }
    },
    MuiListItemText: {
      primary: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      root: {
        maxWidth: 330,
        overflow: 'hidden'
      }
    }
  },
  typography: {
    useNextVariants: false,
    fontFamily: [
      'Open Sans', 'Roboto', 'sans-serif'
    ].join(',')
  }
};

export default lightOrange;
